import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientJsonpModule } from '@angular/common/http';
import { GoogleMapsModule } from '@angular/google-maps';
import { MapComponent } from './map.component';

@NgModule({
    imports: [CommonModule, GoogleMapsModule, HttpClientJsonpModule],
    declarations: [MapComponent],
    exports: [MapComponent],
})
export class MapModule {}
